import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { LoaderService } from './services/loader.service';
// import { UrlService } from './services/url.service';
import { NotificationsService } from './services/notifications.service';
import { MatIconRegistry } from '@angular/material/icon';
import { svg_icons } from '../theme/svg-icon';
import { DomSanitizer } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { KFeathers } from './services/api/feathers.service';
import { LivecoAPIService } from './services/liveco-api.service';
import { AuthService } from './services/auth.service';
import { Marque } from './models/marque.model';
// @ts-ignore
// // const api = require('@modules/cf-api.js').api;;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'Liveco';
    previousUrl: string | null = '/';
    currentUrl: string | null = null;

    get loading(): boolean { return this.loader.loading; }
    get loading$(): Observable<boolean> { return this.loader.loading$; }
    get loading_config() { return this.loader.config; }
    get progress() { return this.loader.progress; }


    subscription = new Subscription();

    constructor(
        public router: Router,
        protected loader: LoaderService,
        protected cd: ChangeDetectorRef,
        // private urlService: UrlService,
        protected notif: NotificationsService,
        protected matIconRegistry: MatIconRegistry,
        protected domSanitizer: DomSanitizer,
        protected s_liveco: LivecoAPIService,
        protected feathers: KFeathers,
        protected s_auth: AuthService,
        @Inject(DOCUMENT) private document: Document
    ) {
        for (let icon of svg_icons)
            this.matIconRegistry.addSvgIcon(icon[0],
                this.domSanitizer.bypassSecurityTrustResourceUrl(icon[1])
            );

        this.feathers.on('connect', async () => {
            await this.getVersion();
        });
    }

    async ngOnInit(): Promise<void> {
        this.subscription.add(this.loading$.subscribe(() => {
            this.cd.detectChanges();
        }));
        this.subscription.add(this.s_auth.onAuthenticated.subscribe(() => {
            this.applyBrandAccentColor();
        }));

        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        // // previous url
        // this.router.events.pipe(
        //   filter((event) => event instanceof NavigationEnd)
        // ).subscribe((event: any) => {
        //   console.log('NAVIGATION EVENT', event);
        //   this.router.navigated = false;
        //   this.previousUrl = this.currentUrl;
        //   this.currentUrl = event.url;

        //   // if(_.isString(this.previousUrl)){
        //   //   this.urlService.previousUrl$.next(this.previousUrl);
        //   // }
        // });

        // const currentVersion = localStorage.getItem('current_version') || '';
        // const reloadVersion: any = await this.s_liveco.find({currentVersion}, '/getVersion');
        // console.log('Liveco version', reloadVersion);

    }


    async getVersion() {
        const version: any = await this.s_liveco.find({}, '/getVersion');
        const currentVersion = version?.result?.currentVersion ?? null;
        const localVersion = localStorage.getItem('current_version');

        console.log('Liveco version', currentVersion, localVersion);
        localStorage.setItem('current_version', currentVersion);

        if (localVersion && currentVersion !== localVersion) {
            this.forceReloadWithoutCache();
        }

    }



    // ngAfterContentChecked() {
    //     this.cd.detectChanges();
    // }


    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subscription.unsubscribe();
    }

    private async forceReloadWithoutCache(): Promise<void> {
        if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            await Promise.all(regs.map(reg => reg.unregister()));
        }

        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map(key => caches.delete(key)));
        }

        const url = new URL(window.location.href);
        url.searchParams.set('reload', Date.now().toString());
        window.location.replace(url.toString());
    }

    private applyBrandAccentColor(): void {
        const accentColor = this.getClientBrandAccentColor();
        const rootStyle = this.document.documentElement.style;

        if (!accentColor) {
            rootStyle.removeProperty('--tw-primary');
            rootStyle.removeProperty('--tw-primary-rgb');
            return;
        }

        rootStyle.setProperty('--tw-primary', accentColor.hex);
        rootStyle.setProperty('--tw-primary-rgb', accentColor.rgb);
    }

    private getClientBrandAccentColor(): { hex: string; rgb: string; } | null {
        if (!this.s_auth.isClient() || this.s_auth.userBrand.length !== 1) {
            return null;
        }

        const brand = this.s_auth.userBrand[0] as Marque;
        return this.parseHexColor(brand?.theme?.accentColor);
    }

    private parseHexColor(color?: string): { hex: string; rgb: string; } | null {
        const value = color?.trim();
        const match = value?.match(/^#?([0-9a-fA-F]{6})$/);
        if (!match) {
            return null;
        }

        const hex = `#${match[1].toUpperCase()}`;
        const rgb = [0, 2, 4]
            .map(index => parseInt(match[1].slice(index, index + 2), 16))
            .join(' ');

        return { hex, rgb };
    }

}
